import { withNamespaces } from "react-i18next";
import { Text, View } from "@react-pdf/renderer";
import styles from "../../Styles";

const FinancialOverview = ({
  t,
  financial_summary,
  money,
  currencyLocal,
  statementDate
}) => {
  const salesAndNetWorthRows = [
    {
      metric: "Annual Sales",
      local: money(financial_summary?.annualSales, currencyLocal),
      usd: money(financial_summary?.annualSalesUs, "USD"),
      statementDate,
    },
    {
      metric: "Net Worth",
      local: money(financial_summary?.netWorth, currencyLocal),
      usd: money(financial_summary?.netWorthUs, "USD"),
      statementDate,
    },
    {
      metric: "Net Income",
      local: money(financial_summary?.netIncome, currencyLocal),
      usd: money(financial_summary?.netIncomeUs, "USD"),
      statementDate,
    },
  ];

  const employeeDataRows = [
    {
      title: "Total Employees (All Locations)",
      details: financial_summary?.employeesTotal ?? "-",
    },
    {
      title: "Local Employees",
      details: financial_summary?.employees ?? "-",
    },
    {
      title: "Total Employee Indication",
      details: "-",
    },
    {
      title: "Includes Principals",
      details: "-",
    },
  ];

  return (
    <View style={styles.section} break>
      {/* Section title */}
      <Text style={styles.sectionSeparator}>
        {`${t("5.")} ${t("Financial Overview")}`}
      </Text>

      {/* 5.1 */}
      <Text style={styles.alphListItem}>
        {`5.1 ${t("Sales and Net Worth")}`}
      </Text>

      {/* 5.1 table (4 columns) */}
      <View style={styles.table} wrap={false}>
        {/* header row */}
        <View style={styles.tableRow} wrap={false} minPresenceAhead={24}>
          <View style={styles.tableColHeader}>
            <Text style={{ ...styles.tableCell, ...styles.fontBold }}>
              {t("Metric")}
            </Text>
          </View>

          <View style={styles.tableColHeader}>
            <Text style={{ ...styles.tableCell, ...styles.fontBold }}>
              {t("Local Currency Value")}
            </Text>
          </View>

          <View style={styles.tableColHeader}>
            <Text style={{ ...styles.tableCell, ...styles.fontBold }}>
              {t("US Dollar Value")}
            </Text>
          </View>

          <View style={{ ...styles.tableColHeader, ...styles.borderRightNone }}>
            <Text style={{ ...styles.tableCell, ...styles.fontBold }}>
              {t("Statement Date")}
            </Text>
          </View>
        </View>

        {/* body rows */}
        {salesAndNetWorthRows.map((r, i) => {
          const rowStyle = {
            ...styles.tableRow,
            ...(i === salesAndNetWorthRows.length - 1
              ? styles.tableLastRow
              : {}),
          };

          return (
            <View style={rowStyle} key={i} wrap={false}>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{t(r.metric)}</Text>
              </View>

              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{r.local ?? "-"}</Text>
              </View>

              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{r.usd ?? "-"}</Text>
              </View>

              <View style={{ ...styles.tableCol, ...styles.borderRightNone }}>
                <Text style={styles.tableCell}>{r.statementDate ?? "-"}</Text>
              </View>
            </View>
          );
        })}
      </View>

      {/* 5.2 */}
      <Text style={styles.alphListItem}>{`5.2 ${t("Employee Data")}`}</Text>

      {/* 5.2 table (2 columns) */}
      <View style={styles.table} wrap={false}>
        {/* header row */}
        <View style={styles.tableRow} wrap={false} minPresenceAhead={24}>
          <View style={styles.tableColHeader}>
            <Text style={{ ...styles.tableCell, ...styles.fontBold }}>
              {t("Title")}
            </Text>
          </View>

          <View style={{ ...styles.tableColHeader, ...styles.borderRightNone }}>
            <Text style={{ ...styles.tableCell, ...styles.fontBold }}>
              {t("Details")}
            </Text>
          </View>
        </View>

        {/* body rows */}
        {employeeDataRows.map((d, i) => {
          const rowStyle = {
            ...styles.tableRow,
            ...(i === employeeDataRows.length - 1 ? styles.tableLastRow : {}),
          };

          return (
            <View style={rowStyle} key={i} wrap={false}>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{t(d.title)}</Text>
              </View>

              <View style={{ ...styles.tableCol, ...styles.borderRightNone }}>
                <Text style={styles.tableCell}>{d.details ?? "-"}</Text>
              </View>
            </View>
          );
        })}
      </View>
    </View>
  );
};

export default withNamespaces()(FinancialOverview);
